import React, { Children } from 'react';

import { Box, Collapse, useDisclosure } from '@chakra-ui/react';

import { ArrowDown, ArrowUp } from 'assets/assetsV1/iconComponents';

import { Tag } from 'uiToolkitV1/Tag';

const ToggleButton = ({ text, onClick = () => {}, icon }) => (
  <Tag StartIcon={icon} variant="tertiarySideNav" onClick={onClick} size="sideNav" buttonColor="grey" mt={2}>
    {text}
  </Tag>
);

const CollapseContainer = ({ onToggle: onToggleProps = () => {}, children }) => {
  const { isOpen, onToggle } = useDisclosure();
  const arrayChildren = Children.toArray(children);
  const visibleArray = arrayChildren.slice(0, 4);
  const collapsedArray = arrayChildren.slice(4);

  if (!collapsedArray.length) {
    return children;
  }

  return (
    <Box mt={1}>
      {visibleArray}
      {!isOpen && (
        <ToggleButton
          text="More Views"
          icon={ArrowDown}
          onClick={() => {
            onToggle();
            onToggleProps();
          }}
        />
      )}
      <Collapse in={isOpen} animateOpacity unmountOnExit>
        {collapsedArray}
      </Collapse>
      {isOpen && <ToggleButton text="Less Views" icon={ArrowUp} onClick={onToggle} />}
    </Box>
  );
};

export { CollapseContainer };
